import { lazy } from "react";
import { Navigate } from "react-router-dom";
const BaseLayoutId = lazy(() => import("src/views/arkadu/BaseLayoutId"));

export default [
  {
    exact: true,
    layout: BaseLayoutId,
    path: "/:customerName/poll/detail/:id",
    component: lazy(() => import("src/views/arkadu/poll/PollDetail")),
  },
  {
    exact: true,
    layout: BaseLayoutId,
    path: "/:customerName/poll/answer/:id",
    component: lazy(() => import("src/views/arkadu/poll/PollAnswer")),
  },
  {
    exact: true,
    path: "/:customerName/poll",
    component: lazy(() => import("src/views/arkadu/poll/PollIndex")),
  },
  {
    component: () => <Navigate to="/404" />,
  },
];
